<template>
  <div>
<!--    <input type="text" className="form-control" placeholder="" v-model="propsValue">-->

    <button type="submit" class="btn btn-primary">儲存</button>
    <button type="submit" class="btn btn-info">回上一頁</button>

    <div class="">
      <form>
        <div class="form-group">
          <label for="" class="">姓名</label>
          <input type="text" class="form-control" id="txtName" name="txtName" placeholder="" value="楊清壬">
        </div>
        <div class="form-group">
          <label for="" class=" ">受傷部位</label>
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="chkItem1" name="chkItem1" value="1">
            <label class="form-check-label" for="chkItem1">頸髓</label>
          </div>
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="chkItem2" name="chkItem2" value="2">
            <label class="form-check-label" for="chkItem2">胸髓第六節以上</label>
          </div>
        </div>
        <div class="form-group">
          <label for="" class=" ">慢性疾病</label>
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="chkItem1" name="chkItem1" value="1">
            <label class="form-check-label" for="chkItem1">高血壓</label>
          </div>
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="chkItem2" name="chkItem2" value="2">
            <label class="form-check-label" for="chkItem2">糖尿病</label>
          </div>
        </div>
        <div class="form-group">
          <label for="" class="">備註</label>
          <textarea class="form-control" id="txtMemo" name="txtMemo" rows="3"></textarea>
        </div>

<!--        <div class="form-group">-->
<!--          <button type="submit" class="btn btn-primary">確定</button>-->
<!--          <button type="submit" class="btn btn-danger">取消</button>-->
<!--        </div>-->
      </form>
    </div>


  </div>
</template>

<script>
/**

 **/


export default {
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
    };
  },
  watch: {
    propsValue(newVal) {
      //this.('input', newVal);
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
  },
  mounted() {
    // this.initValue()
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
